<!-- @format -->

<div class="calendarContainer">
	<div class="monthName">
		{{monthName}} @if (getIsTimesheetView()) {
		{{calendarData.year}}
		}
	</div>
	<div class="calendar">
		@if (getIsYearView()) {
		<div class="weeks">
			<span>Sa</span>
			<span>Su</span>
			<span>Mo</span>
			<span>Tu</span>
			<span>We</span>
			<span>Th</span>
			<span>Fr</span>
		</div>
		} @if (getIsTimesheetView()) {
		<div class="weeks">
			<span>Sat</span>
			<span>Sun</span>
			<span>Mon</span>
			<span>Tue</span>
			<span>Wed</span>
			<span>Thu</span>
			<span>Fri</span>
		</div>
		}

		<div class="days">
			@for (timesheet of calendarData.timesheets; track timesheet.payPeriodStartDate; let timesheetIndex = $index) {
			<div class="week">
				@for (loop of [].constructor(7); track $index; let currentDay = $index) {
				<div
					class="day"
					[class.dayBorder]="getShouldShowDay(timesheet, currentDay)"
					[class.selectedTimesheet]="getIsSelectedTimesheet(timesheet)"
					[class.isStat]="getIsStatHoliday(timesheet, currentDay)"
					[class.shouldShadeEntry]="getShouldShadeTimesheetEntries(timesheet, currentDay)"
					[class.timesheetView]="getIsTimesheetView()"
					[class.workWeekDay]="getShouldEnableDayHover(timesheet, currentDay)"
					(click)="handleTimesheetClick(timesheet)">
					@if (getIsPayDay(timesheet, currentDay)) {
					<div class="triangle triangle_tl"></div>
					} @if (getIsHolidayClosure(timesheet, currentDay)) {
					<div class="triangle triangle_tr"></div>
					} @if (getIsCDODay(timesheet, currentDay)) {
					<div class="CDO"></div>
					} @if (shouldHighlightCurrentDay(timesheet, currentDay)) {
					<div class="currentDayHighlight"></div>
					}
					<span
						class="dayEntry"
						[class.CDO]="getIsCDODay(timesheet, currentDay)"
						[class.inActiveDate]="getIsNeighborMonth(timesheet, currentDay)"
						[class.currentDayHighlight]="shouldHighlightCurrentDay(timesheet, currentDay)">
						{{ getCurrentDate(timesheet, currentDay) }}
					</span>
					<div class="timesheetBarContainer">
						@if (getShouldShowAdvancedTooltip(timesheet, currentDay)) {
						<div
							class="calendarBar"
							[class.roundedBoarder]="getIsTimesheetView()"
							[style]="getCalendarBarStyles(timesheet, currentDay)"></div>
						@if (getIsSavedOrPredictedData(timesheet)) {
						<div class="calendarBar unsubmittedMask" [class.roundedBorder]="getIsTimesheetView()"></div>
						} } @if (getShouldShowBasicTooltip(timesheet, currentDay) || getShouldShowAdvancedTooltip(timesheet, currentDay)) { @if
						(getIsYearView()) {
						<div class="arrow-up"></div>
						} @if (getIsYearView()) {
						<div class="timesheetHoverPanel">
							@if (isFilterEntry(timesheet, currentDay)) { @if (getIsPayDay(timesheet, currentDay)) {
							<div class="entryRow">
								<div class="tooltipPayDay">
									<div class="triangle triangle_tl_small"></div>
								</div>
								<span class="tooltipFilterText">Pay Day</span>
							</div>
							} @if (getIsHolidayClosure(timesheet, currentDay)) {
							<div class="entryRow">
								<div class="tooltipHolidayClosure">
									<div class="triangle triangle_tr_small"></div>
								</div>
								<span class="tooltipFilterText">Holiday Closure</span>
							</div>
							} @if (getIsStatHoliday(timesheet, currentDay)) {
							<div class="entryRow">
								<div class="tooltipStat stat"></div>
								<span class="tooltipFilterText">{{getStatHolidayName(timesheet, currentDay)}}</span>
							</div>
							} @if (getIsCDODay(timesheet, currentDay)) {
							<div class="entryRow">
								<div class="tooltipCDO">
									<div class="cdo_small"></div>
								</div>
								<span class="tooltipFilterText">Compressed Day Off</span>
							</div>
							} } @if (getShouldShowAdvancedTooltip(timesheet, currentDay)) { @if (getShouldShowBasicTooltip(timesheet, currentDay)) {
							<hr />
							} @for (entry of timesheet.entries; track entry.name) { @if (getHasEntryWithDuration(entry, currentDay)) {
							<div class="entryRow">
								<div class="timeEntryColor" [style]="getTimesheetEntryColorStyling(entry)"></div>
								<div class="timeEntryEntryType">{{entry.name}}</div>
								<div class="timeEntryEntryTime">{{getTimeEntryEntryTimeAmount(entry, currentDay)}}</div>
							</div>
							} }
							<div class="entryRow">
								<div class="timeEntryTotalText">TOTAL</div>
								<div class="timeEntryTotalTime">{{getTotalCalculatedTime(timesheet, currentDay)}}</div>
							</div>
							}
						</div>
						} }
					</div>
				</div>
				}
			</div>
			}
		</div>
	</div>
</div>
